import { useState } from "react";
import { Sparkle } from "lucide-react";
import { api } from "../lib/api";

export default function Reflections({ slug }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const load = async () => {
    setBusy(true); setErr("");
    try { const r = await api.get(`/ai/reflect/${slug}`); setData(r.data); }
    catch (e) { setErr(e?.response?.data?.detail || "Reflection failed. Try again."); }
    setBusy(false);
  };

  if (!data) {
    return (
      <div data-testid="reflections-panel">
        <button onClick={load} disabled={busy} className="w-full flex items-center gap-3 border border-[var(--line)] p-4 hover:border-[var(--bone)] transition-colors text-left disabled:opacity-60" data-testid="reflections-load-button">
          <Sparkle size={16} className={busy ? "animate-spin text-[var(--signal)]" : ""} />
          <span>
            <span className="block f-mono text-[11px] text-[var(--ash)] uppercase">Reflections</span>
            <span className="block f-display font-bold uppercase text-lg leading-tight">{busy ? "Distilling\u2026" : "Distil this piece"}</span>
          </span>
        </button>
        {err && <p className="text-sm text-[var(--signal)] mt-2">{err}</p>}
      </div>
    );
  }
  return (
    <div className="border border-[var(--line)] p-5" data-testid="reflections-panel">
      <p className="eyebrow mb-3">Distilled</p>
      <p className="f-serif italic text-lg leading-snug text-[#d8d7d1]" data-testid="reflections-summary">{data.summary}</p>
      <p className="eyebrow mt-6 mb-3">Sit with</p>
      <ol className="space-y-3">
        {(data.prompts || []).map((p, i) => (
          <li key={i} className="flex gap-3 text-[#cfcec8]"><span className="f-mono text-[11px] text-[var(--ash)] pt-1">0{i + 1}</span><span>{p}</span></li>
        ))}
      </ol>
      <p className="f-mono text-[11px] text-[var(--ash)] mt-5">AI distillation</p>
    </div>
  );
}
